import React from 'react'
import { Link } from 'react-router-dom';
import SplashScreen from '../common/Splash/screen';
import skills from './skills.json';
import projects from '../Projects/projects.json';
import experiences from "../Experiences/experience.json";
import { FiExternalLink } from "react-icons/fi";

const Skills = () => {
    const relatedProjects = {
        "dis_devops": [],
        "software": [],
        "data_science": []
    }
    const relatedExp = {
        "dis_devops": [],
        "research": [],
        "software": [],
        "data_science": [],
        "leadership": []
    }
    projects.forEach((project) => {
        if (project.type === "cld") {
            relatedProjects["dis_devops"].push({
                "link": project.link,
                "title": project.title
            });
        }
        else if (project.type === "swe") {
            relatedProjects["software"].push({
                "link": project.link,
                "title": project.title
            });
        }
        else if (project.type === "ds") {
            relatedProjects["data_science"].push({
                "link": project.link,
                "title": project.title
            });
        }
    })
    experiences.professional.forEach((exp) => {
        if ((exp.skills.includes("Distributed Systems")) || ( exp.skills.includes("DevOps")) || ( exp.skills.includes("Cloud Computing"))) {
            relatedExp["dis_devops"].push(`${exp.role} at ${exp.organization}`);
        }
        if (( exp.skills.includes("Full Stack Development")) || ( exp.skills.includes("Backend Development")) || ( exp.skills.includes("Frontend Development"))) {
            relatedExp["software"].push(`${exp.role} at ${exp.organization}`);
        }
        if ( exp.skills.includes("Research & Development")) {
            relatedExp["research"].push(`${exp.role} at ${exp.organization}`);
        }
        if (( exp.skills.includes("Leadership")) || ( exp.skills.includes("Team Management"))) {
            relatedExp["leadership"].push(`${exp.role} at ${exp.organization}`);
        }
        if ( exp.skills.includes("Data Science")) {
            relatedExp["data_science"].push(`${exp.role} at ${exp.organization}`);
        }
    })
    return(
        <div id='skills'>
            <SplashScreen name="Skills" bgColor="white" color="#82047F" photo="/assets/credentials/all2.png" />
            <div className='center'>
                <div className='cred_right'>
                    <div className='center' style={{width: "95vw", justifyContent: "flex-start", backgroundColor: "#750072", alignItems:"flex-start", alignItems:"flex-start"}}>
                        <div className='container' style={{marginLeft: "5vh", marginTop: "5vh"}}>
                            <div className='poster'>
                                Distributed Systems & DevOps
                                <div className='poster_hr'/>
                                <div  className='rlt_t'>
                                    Related Experiences
                                </div>
                                {
                                    relatedExp["dis_devops"].map((exp) => {
                                        return <div>
                                            <div className='related'>
                                                {exp}
                                            </div>
                                        </div>
                                    })
                                }
                                <div  className='rlt_t'>
                                    Related Projects
                                </div>
                                {
                                    relatedProjects["dis_devops"].map((project) => {
                                        return <div>
                                            <Link to={project.link} className='related'>
                                                {project.title} <FiExternalLink/>
                                            </Link>
                                        </div>
                                    })
                                }
                            </div>
                        </div>
                        <div id='Distributed Systems' className='skill_list center' style={{flexWrap: "wrap", justifyContent: "flex-start"}}>
                            {skills['Distributed Systems & DevOps'].map((skill) => {
                                return <div className='pf_skill center flex_column'>
                                    <div className='skill_title center'>
                                        {skill.name}
                                    </div>
                                    <div className='skill_sub center'>
                                        {skill.sub}
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>
                    <div className='center' style={{width: "95vw", justifyContent: "flex-start", backgroundColor: "#52004F", alignItems:"flex-start", alignItems:"flex-start"}}>
                        <div className='container' style={{marginLeft: "5vh", marginTop: "5vh"}}>
                            <div className='poster'>
                                Research & Development
                                <div className='poster_hr'/>
                                <div  className='rlt_t'>
                                    Related Experiences
                                </div>
                                {
                                    relatedExp["research"].map((exp) => {
                                        return <div>
                                            <div className='related'>
                                                {exp}
                                            </div>
                                        </div>
                                    })
                                }
                            </div>
                        </div>
                        <div id='Research & Development' className='skill_list center' style={{flexWrap: "wrap"}}>
                            {skills['Research & Development'].map((skill) => {
                                return <div className='pf_skill center flex_column'>
                                    <div className='skill_title center'>
                                        {skill.name}
                                    </div>
                                    <div className='skill_sub center'>
                                        {skill.sub}
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>
                    <div className='center' style={{width: "95vw", justifyContent: "flex-start", backgroundColor: "#470044", alignItems:"flex-start", alignItems:"flex-start"}}>
                        <div className='container' style={{marginLeft: "5vh", marginTop: "5vh"}}>
                            <div className='poster'>
                                Software Engineering
                                <div className='poster_hr'/>
                                <div  className='rlt_t'>
                                    Related Experiences
                                </div>
                                {
                                    relatedExp["software"].map((exp) => {
                                        return <div>
                                            <div className='related'>
                                                {exp}
                                            </div>
                                        </div>
                                    })
                                }
                                <div  className='rlt_t'>
                                    Related Projects
                                </div>
                                {
                                    relatedProjects["software"].map((project) => {
                                        return <div>
                                            <Link to={project.link} className='related'>
                                                {project.title} <FiExternalLink/>
                                            </Link>
                                        </div>
                                    })
                                }
                            </div>
                        </div>
                        <div id='Software Engineering' className='skill_list center' style={{flexWrap: "wrap"}}>
                            {skills['Software Engineering'].map((skill) => {
                                return <div className='pf_skill center flex_column'>
                                    <div className='skill_title center'>
                                        {skill.name}
                                    </div>
                                    <div className='skill_sub center'>
                                        {skill.sub}
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>
                    <div className='center' style={{width: "95vw", justifyContent: "flex-start", backgroundColor: "#2E002C", alignItems:"flex-start", alignItems:"flex-start"}}>
                        <div className='container' style={{marginLeft: "5vh", marginTop: "5vh"}}>
                            <div className='poster'>
                                Data Science
                                <div className='poster_hr'/>
                                <div  className='rlt_t'>
                                    Related Experiences
                                </div>
                                {
                                    relatedExp["data_science"].map((exp) => {
                                        return <div>
                                            <div className='related'>
                                                {exp}
                                            </div>
                                        </div>
                                    })
                                }
                                <div  className='rlt_t'>
                                    Related Projects
                                </div>
                                {
                                    relatedProjects["data_science"].map((project) => {
                                        return <div>
                                            <Link to={project.link} className='related'>
                                                {project.title} <FiExternalLink/>
                                            </Link>
                                        </div>
                                    })
                                }
                            </div>
                        </div>
                        <div id='Data Science' className='skill_list center' style={{flexWrap: "wrap"}}>
                            {skills['Data Science'].map((skill) => {
                                return <div className='pf_skill center flex_column'>
                                    <div className='skill_title center'>
                                        {skill.name}
                                    </div>
                                    <div className='skill_sub center'>
                                        {skill.sub}
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>
                    <div className='center' style={{width: "95vw", justifyContent: "flex-start", backgroundColor: "#20001F", alignItems:"flex-start", alignItems:"flex-start"}}>
                        <div className='container' style={{marginLeft: "5vh", marginTop: "5vh"}}>
                            <div className='poster'>
                                Leadership
                                <div className='poster_hr'/>
                                <div  className='rlt_t'>
                                    Related Experiences
                                </div>
                                {
                                    relatedExp["leadership"].map((exp) => {
                                        return <div>
                                            <div className='related'>
                                                {exp}
                                            </div>
                                        </div>
                                    })
                                }
                            </div>
                        </div>
                        <div id='Leadership' className='skill_list center' style={{flexWrap: "wrap"}}>
                            {skills['Leadership'].map((skill) => {
                                return <div className='pf_skill center flex_column'>
                                    <div className='skill_title center'>
                                        {skill.name}
                                    </div>
                                    <div className='skill_sub center'>
                                        {skill.sub}
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>
                    <div className='center' style={{width: "95vw", justifyContent: "flex-start", backgroundColor: "#110011", alignItems:"flex-start", alignItems:"flex-start"}}>
                        <div className='container' style={{marginLeft: "5vh", marginTop: "5vh"}}>
                            <div className='poster'>
                                Tools
                                <div className='poster_hr'/>
                            </div>
                        </div>
                        <div id='Tools' className='skill_list center' style={{flexWrap: "wrap"}}>
                            {skills['Tools'].map((skill) => {
                                return <div className='pf_skill center flex_column'>
                                    <div className='skill_title center'>
                                        {skill.name}
                                    </div>
                                    <div className='skill_sub center'>
                                        {skill.sub}
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Skills;